import {
	getAllUsersStart,
	getAllUsersSucSuccess,
	getAllUsersFailure,
	getAllStudentsStart,
	getAllStudentsSucSuccess,
	getAllStudentsFailure,
	getAllUserByIdStart,
	getAllUserByIdSucSuccess,
	getAllUserByIdFailure,
} from '../reducers/users';

import axios from "../../api/axios";

export const getAllUsers = (page, pageSize, query) => async (dispatch) => {
	dispatch(getAllUsersStart());
	try {
		const response = await axios.get(`/users/getAllUsers?page=${page}&pageSize=${pageSize}&search=${query}`,
			{
				withCredentials: true,
			});
		if (response.status === 200) {
			dispatch(getAllUsersSucSuccess(response.data));
			return {
				status: response.status,
				totalRows: response.data.total,
				page: response.data.page,
				pageSize: response.data.pageSize
			};
		}
		return response.status;
	} catch (error) {
		dispatch(getAllUsersFailure());
	}
};

/**
 * Listado de estudiantes (POST JSON): filtros, sort por columna, columnSearch, Excel opcional.
 * POST /users/getAllStudents
 */
export const getAllStudents = (payload = {}) => async (dispatch) => {
	const sendExcel = payload.sendExcel === true;
	if (!sendExcel) {
		dispatch(getAllStudentsStart());
	}
	try {
		const response = await axios.post(`/users/getAllStudents`, payload, {
			withCredentials: true,
		});
		if (response.status === 200) {
			if (!sendExcel) {
				dispatch(getAllStudentsSucSuccess(response.data));
			}
			return {
				status: response.status,
				totalRows: response.data.total,
				page: response.data.page,
				pageSize: response.data.pageSize,
				excelData: response.data.excelData,
			};
		}
	} catch (error) {
		if (!sendExcel) {
			dispatch(getAllStudentsFailure());
		}
		return { status: error?.response?.status || 500 };
	}
};

export const getUserById = (
	idUser,
	recordsPage = 1,
	recordsLimit = 10,
	recordsSort = 'desc',
	recordsCategory = 'all'
) => async (dispatch) => {
	dispatch(getAllUserByIdStart());
	try {
		const toCsv = (v) => (Array.isArray(v) ? v.filter(Boolean).join(',') : (v || ''));
		const categoryParam = Array.isArray(recordsCategory)
			? (recordsCategory.length === 0 ? 'all' : toCsv(recordsCategory))
			: (recordsCategory || 'all');
		const response = await axios.get(`/users/getUserById/${idUser}?recordsPage=${recordsPage}&recordsLimit=${recordsLimit}&recordsSort=${recordsSort}&recordsCategory=${categoryParam}`);
		dispatch(getAllUserByIdSucSuccess(response.data))
		return response.data;
	} catch (error) {
		dispatch(getAllUserByIdFailure());
	}
};

export const createNewUserByInvitation = ({ email, typeUser }) => async (dispatch) => {
	try {
		const response = await axios.post(`/users/newUserByInvitation`,
			{
				email,
				typeUser
			},
			{
				withCredentials: true,
			});
		if (response.status === 201) {

			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};

export const createNewUser = (payload) => async (dispatch) => {

	const { firstName, secondName, lastName, secondSurname, email, location, typeUser, phone, dateBirth, password
	} = payload;

	try {
		const response = await axios.post(`/users/`,
			{
				firstName,
				secondName,
				lastName,
				secondSurname,
				email,
				location,
				typeUser,
				phone,
				dateBirth,
				password
			});
		if (response.status === 201) {

			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};

export const updateProfileUser = (data, userId) => async (dispatch) => {
	try {
		const response = await axios.put(`users/update-profile/${userId}`,
			{
				data
			});
		if (response.status === 201) {
			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};

export const updateProfileUser2 = (data, userId) => async (dispatch) => {
	try {
		const response = await axios.put(`users/update-profile/${userId}`,
			{
				data
			});
		if (response.status === 201) {
			return {
				status: response.status,
				message: response.data.message
			};
		}
	} catch (error) {
		return {
			status: error.response.status,
			message: error.response.data.message
		};
	}
};
